import * as React from 'react'
import SiteConfig from '../../model/SiteConfig'
import Autosuggest, { SuggestionsFetchRequestedParams } from 'react-autosuggest'
import { Badge } from 'react-bootstrap'
import { FaBolt } from 'react-icons/fa'

interface DispatchProps {
  changeSite: (siteConfig: SiteConfig) => void
}
interface StateProps {
  siteConfigList: SiteConfig[],
  sitesLoading: boolean
}
type Props = DispatchProps & StateProps

interface State {
  suggestions: SiteConfig[]
  value: string
}
const LOADING_SITES_KEY = 'LOADING_SITES'

export class SiteSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: '',
      suggestions: []
    }
  }


  getLoadingSiteConfig = () => {
    var config = new SiteConfig();
    config.name = LOADING_SITES_KEY;
    config.key = LOADING_SITES_KEY;
    return config;
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = (value: string): SiteConfig[] => {
    const inputValue = value.trim().toLocaleLowerCase()
    const inputLength = inputValue.length

    var items = inputLength === 0
      ? []
      : this.props.siteConfigList
          .filter(siteConfig => siteConfig.name.toLocaleLowerCase().includes(inputValue))
          .sort((a, b) => a.name.localeCompare(b.name))
          .slice(0, 10)
    if(this.props.sitesLoading) {
      items.push(this.getLoadingSiteConfig())
    }
    return items;
  }

  // Use your imagination to render suggestions.
  renderSuggestion = (suggestion: SiteConfig) => suggestion.key === LOADING_SITES_KEY ? 
  <Badge>
    <FaBolt /> Loading more sites...
  </Badge> : 
    <div>{suggestion.name}</div>

  onChange = (_: unknown, params: Autosuggest.ChangeEvent) => {
    if(params.newValue === LOADING_SITES_KEY) return;
    this.setState({
      value: params.newValue
    })
    if (params.method === 'click') this.tryChangeSite(params.newValue)
  }

  onKeyPress = (event: React.KeyboardEvent<any>) => {
    if (event.key === 'Enter') {
      this.tryChangeSite(this.state.value)
    }
  }

  onBlur = () => this.tryChangeSite(this.state.value)

  tryChangeSite = (value: string) => {
    var selectedSite = this.props.siteConfigList.find(
      siteConfig => siteConfig.name.toLocaleLowerCase() === value.toLocaleLowerCase()
    )
    if (selectedSite) {
      this.setState({
        value: ''
      })
      this.props.changeSite(selectedSite)
    }
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = (request: SuggestionsFetchRequestedParams) => {
    this.setState({
      suggestions: this.getSuggestions(request.value)
    })
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    })
  }

  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
  getSuggestionValue = (suggestion: SiteConfig) => suggestion.name

  render() {
    const inputProps: Autosuggest.InputProps<SiteConfig> = {
      placeholder: 'Type part of a site name',
      value: this.state.value,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      onBlur: this.onBlur
    }
    return (
      <Autosuggest
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
      />
    )
  }
}
